import React from 'react';
import { Icon } from './Icon';

const AgeIcon = ({ size }: Props) => {
  return (
    <Icon type="woman" color="bg-label-warning" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { AgeIcon };